import { Box, Chip, Tab, Tabs } from '@mui/material';
import React, { useMemo, useState } from 'react';

import DiffView from './DiffView';
import RawSavedEntryView from './RawSavedEntryView';
import { EntryDiffViewerProps } from './types';
import { generateDiff } from './utils';

const EntryDiffViewer: React.FC<EntryDiffViewerProps> = ({
  savedEntry,
  calculatedLines,
}) => {
  const [activeTab, setActiveTab] = useState(0);

  const diff = useMemo(
    () => generateDiff(savedEntry, calculatedLines),
    [savedEntry, calculatedLines],
  );

  return (
    <Box
      sx={{
        p: 2,
        minWidth: 650,
        maxWidth: 850,
        maxHeight: 500,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box sx={{ borderBottom: 2, borderColor: '#0288d1', mb: 1.5 }}>
        <Tabs
          value={activeTab}
          onChange={(_, newValue) => setActiveTab(newValue)}
          sx={{
            minHeight: 36,
            '& .MuiTab-root': {
              minHeight: 36,
              py: 0.5,
              fontSize: '0.85rem',
              color: '#666',
              '&.Mui-selected': { color: '#0288d1' },
            },
            '& .MuiTabs-indicator': { backgroundColor: '#0288d1' },
          }}
        >
          <Tab
            label={
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <span>Diferencias</span>
                <Chip
                  size="small"
                  label={diff.totalDifferences}
                  color={diff.totalDifferences === 0 ? 'success' : 'warning'}
                  sx={{ height: 20, fontSize: '0.7rem' }}
                />
              </Box>
            }
          />
          <Tab label="Asiento Guardado" />
        </Tabs>
      </Box>

      <Box sx={{ flex: 1, overflow: 'hidden' }}>
        {activeTab === 0 && <DiffView diff={diff} />}
        {activeTab === 1 && <RawSavedEntryView savedEntry={savedEntry} />}
      </Box>
    </Box>
  );
};

export default EntryDiffViewer;

export type { CalculatedLine, SavedEntry, SavedEntryLine } from './types';
